import React, { FC, useCallback } from 'react';
import { Input, Form } from 'src/common';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import pStyles from '../index.module.scss';

export enum LayoutMode {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

interface IKeywordsInputProps {
  addKeyword: (keyword: string) => void;
  disabled?: boolean;
  label: string;
  layoutMode?: LayoutMode;
  existingKeywords?: string[];
}

// @see: https://tendium.atlassian.net/browse/PROM-534
export const STOP_WORDS = [
  'i',
  'me',
  'my',
  'myself',
  'we',
  'our',
  'ours',
  'ourselves',
  'you',
  'your',
  'yours',
  'yourself',
  'yourselves',
  'he',
  'him',
  'his',
  'himself',
  'she',
  'her',
  'hers',
  'herself',
  'it',
  'its',
  'itself',
  'they',
  'them',
  'their',
  'theirs',
  'themselves',
  'what',
  'which',
  'who',
  'whom',
  'this',
  'that',
  'these',
  'those',
  'am',
  'is',
  'are',
  'was',
  'were',
  'be',
  'been',
  'being',
  'have',
  'has',
  'had',
  'having',
  'do',
  'does',
  'did',
  'doing',
  'a',
  'an',
  'the',
  'and',
  'but',
  'if',
  'or',
  'because',
  'as',
  'until',
  'while',
  'of',
  'at',
  'by',
  'for',
  'with',
  'about',
  'against',
  'between',
  'into',
  'through',
  'during',
  'before',
  'after',
  'above',
  'below',
  'to',
  'from',
  'up',
  'down',
  'in',
  'out',
  'on',
  'off',
  'over',
  'under',
  'again',
  'further',
  'then',
  'once',
  'here',
  'there',
  'when',
  'where',
  'why',
  'how',
  'all',
  'any',
  'both',
  'each',
  'few',
  'more',
  'most',
  'other',
  'some',
  'such',
  'no',
  'nor',
  'not',
  'only',
  'own',
  'same',
  'so',
  'than',
  'too',
  'very',
  's',
  't',
  'can',
  'will',
  'just',
  'don',
  'should',
  'now'
];
export const KeywordsInput: FC<IKeywordsInputProps> = ({ layoutMode = LayoutMode.Horizontal, ...restProps }) => {
  const { addKeyword, disabled, label, existingKeywords } = restProps;
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const handleSubmit = useCallback(
    (values: { keyword: string }): void => {
      const { keyword } = values;
      const trimmed = keyword.trim();
      if (trimmed.length && !disabled) {
        addKeyword(trimmed);
      }
      form.setFieldsValue({
        keyword: ''
      });
    },
    [addKeyword, disabled, form]
  );

  return (
    <li className={pStyles.keywordsItem}>
      <Form
        className={classNames(styles.keywordCreateBox, { [styles.vertical]: layoutMode === LayoutMode.Vertical })}
        onFinish={handleSubmit}
        form={form}
      >
        <Form.Item
          className={styles.keywordCreateInput}
          name={'keyword'}
          rules={[
            () => ({
              validateTrigger: 'onBlur',
              async validator(_, value) {
                if (STOP_WORDS.includes(String(value).toLowerCase()))
                  throw new Error(t('Tenders.searchDocumentsNotAllowedKeyword'));
                else if (existingKeywords && existingKeywords.includes(String(value).toLowerCase()))
                  throw new Error(t('KeywordSearch.keywordAlreadyAddedError'));
              }
            })
          ]}
        >
          <Input type={'text'} placeholder={label} disabled={disabled} />
        </Form.Item>
      </Form>
    </li>
  );
};

export default KeywordsInput;
